import { z } from "zod";

import { intIdCodec, intIdSchema } from "@/codecs/intId";

export const coreCredentialGradeIdSchema =
  intIdSchema.brand<"CoreCredentialGradeId">();
export type CoreCredentialGradeId = z.infer<typeof coreCredentialGradeIdSchema>;

export const cohireCredentialGradeSchema = z
  .string()
  .min(1)
  .brand<"CohireCredentialGrade">();
export type CohireCredentialGrade = z.infer<typeof cohireCredentialGradeSchema>;

export const credentialGradeIdSchema = z.union([
  coreCredentialGradeIdSchema,
  cohireCredentialGradeSchema,
]);
export type CredentialGradeId = z.infer<typeof credentialGradeIdSchema>;

export const coreCredentialGradeIdCodec = intIdCodec(
  coreCredentialGradeIdSchema,
);
